export const types = {
  HEARING: "HEARING",
  DEADLINE: "DEADLINE",
  TASK: "TASK",
  APPOINTMENT: "APPOINTMENT",
  EVENT: "EVENT",
  ALL: "ALL",
};

export default {
  HEARING: { label: "Audiência", pluralLabel: "Audiências", key: types.HEARING },
  DEADLINE: { label: "Prazo", pluralLabel: "Prazos", key: types.DEADLINE },
  TASK: { label: "Tarefa", pluralLabel: "Tarefas", key: types.TASK },
  APPOINTMENT: { label: "Evento", pluralLabel: "Eventos", key: types.APPOINTMENT },
  ALL: { label: "Todos", pluralLabel: "Todos", key: types.ALL },
};
